import React from 'react';
import { Provider, Store } from 'react-redux';
import { combineReducers, createStore } from 'redux';
import { createEpicMiddleware } from 'redux-observable';

import { Action } from '../../../actions';
import { canvasEditorReducer } from '../../../reducers/canvasEditor';
import { CanvasEditorState } from '../../../typings/state';
import { CanvasApi } from '../../api/CanvasApi';
import { applyReduxMiddleware } from '../../common/helpers';
import { SharedData } from '../../common/typings';
import { hideBusy } from '../../Html5App/actions';
import { html5Epics } from '../../Html5App/epics';
import { Html5AppContainer } from '../../Html5App/Html5AppContainer';
import { getInitialHtml5AppState } from '../../Html5App/reducers';
import { Html5Page } from '../../Html5App/typings';

interface Html5AppWrapperProps {
    sharedData: SharedData;
    page: Html5Page;
    onClose: () => void;
    onCreativesSelect: (ids: number[]) => void;
}

interface Html5EpicDeps {
    canvasApi: CanvasApi;
}

interface WrapperState {
    canvasEditor: CanvasEditorState;
}

export class Html5AppWrapper extends React.PureComponent<Html5AppWrapperProps> {
    private readonly store: Store<WrapperState>;

    constructor(props: Html5AppWrapperProps) {
        super(props);

        const epicDeps = this.getEpicDeps();
        const epicMiddleware = createEpicMiddleware<Action, Action, WrapperState, Html5EpicDeps>({
            dependencies: epicDeps
        });

        this.store = createStore(
            combineReducers({ canvasEditor: canvasEditorReducer }),
            this.buildPreloadedState(props),
            applyReduxMiddleware(epicMiddleware)
        );

        epicMiddleware.run(html5Epics);
    }

    public unlock(): void {
        this.store.dispatch(hideBusy());
    }

    render(): React.ReactNode {
        const { page, onClose, onCreativesSelect } = this.props;

        return (
            <Provider store={this.store}>
                <Html5AppContainer page={page} onClose={onClose} onCreativesSelect={onCreativesSelect} />
            </Provider>
        );
    }

    private buildPreloadedState(props: Html5AppWrapperProps) {
        return {
            canvasEditor: {
                sharedData: props.sharedData,
                settings: {},
                html5: {
                    ...getInitialHtml5AppState(props.sharedData),
                    page: props.page
                },
                itemNameEditors: {}
            }
        };
    }

    private getEpicDeps(): Html5EpicDeps {
        return {
            canvasApi: new CanvasApi()
        };
    }
}
